<template>
  <div>
    <va-card class="overflow-auto">
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <div class="row">
        <div class="flex md6 sm6 xs12">
          <h4 style="font-size: 24px !important" class="card-title mx-2">
            CRIME REPORTS
          </h4>
        </div>
      </div>
      <b-row class="pb-4">
        <b-col cols="12">
          <b-input-group prepend="Search key" class="mt-3">
            <b-form-input
              v-model="keyword"
              placeholder="Please Enter UserId or CrimeId"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="info">
                <i class="fa fa-search"></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-modal v-model="assignModal" hide-header hide-footer>
        <b-row class="pa-3">
          <b-col cols="12">
            <span style="font-size: 18px; font-weight: 600">
              Assign to Analyst
            </span>
          </b-col>
          <b-col cols="12" class="py-3">
            <div v-if="selectedCrime && selectedCrime.requestedBy && selectedCrime.requestedBy.length > 0" class="mb-3 p-2 bg-light border rounded">
              <span style="font-weight: 600; font-size: 13px; color: #dc3545;">Suggested Analyst(s) (Requested):</span>
              <div class="mt-1">
                <b-badge
                  v-for="req in selectedCrime.requestedBy"
                  :key="typeof req === 'object' ? req._id : req"
                  @click="analystId = (typeof req === 'object' ? req._id : req)"
                  variant="info"
                  class="mr-1"
                  style="cursor: pointer; font-size: 12px;"
                  v-b-tooltip.hover
                  title="Click to select this analyst"
                >
                  {{ getAnalystName(req) }}
                </b-badge>
              </div>
            </div>
            <span>Please select an analyst</span>
            <b-form-select
              v-model="analystId"
              value-field="_id"
              text-field="name"
              :options="analysts"
            ></b-form-select>
          </b-col>
          <b-col cols="12">
            <b-row>
              <b-col cols="3">
                <b-button @click="assign()" variant="success">
                  Submit
                </b-button>
              </b-col>
              <b-col cols="3">
                <b-button @click="assignModal = false" variant="danger">
                  Cancel
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-modal>
      <div class="row">
        <div class="col-md-6">
          <h5>*Select the options to filter the results</h5>
        </div>
        <div v-if="appUser.usertype == 0" class="col-md-6 text-right">
          <b-button variant="success" size="sm" class="mr-2" @click="exportCrimeReports()">Export Crime Reports (Excel)</b-button>
          <!-- <b-button variant="primary" size="sm" class="mr-2" @click="exportOffenders()">Export Accused DB (Excel)</b-button> -->
          <router-link to="/analytics">
            <b-button variant="info" size="sm">View Analytics</b-button>
          </router-link>
        </div>
      </div>
      <div class="row">
        <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label
              for="exampleInputEmail1"
              style="text-align: left !important"
            ></label>
            <select
              class="filter pt-2 pb-2"
              style="width: 100% !important"
              v-model="usertype"
            >
              <option value selected disabled hidden>User Type</option>
              <option v-bind:value="null">All</option>
              <option>user</option>
              <option>guest</option>
            </select>
          </div>
        </div>

        <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label
              for="exampleInputEmail1"
              style="text-align: left !important"
            ></label>
            <select
              class="filter pt-2 pb-2"
              style="width: 100% !important"
              v-model="crimeType"
            >
              <option value selected disabled hidden>Crime Type</option>
              <option v-bind:value="null">All</option>
              <option v-for="ct in ctype" :key="ct._id" v-bind:value="ct._id">
                {{ ct.cname }}
              </option>
            </select>
          </div>
        </div>
        <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label
              for="exampleInputEmail1"
              style="text-align: left !important"
            ></label>
            <select
              class="filter pt-2 pb-2"
              style="width: 100% !important"
              v-model="CRtype"
            >
              <option value selected disabled hidden>Level of Reporting</option>
              <option v-bind:value="null">All</option>
              <option value="online">Online Reporting</option>
              <option value="groundlevel">Field Reporting</option>
            </select>
          </div>
        </div>
        <!-- <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label for="exampleInputEmail1" style="text-align: left!important;"></label>
            <select class="filter" v-model="source">
              <option value selected disabled hidden>Source</option>
              <option v-for="info in Sour" :key="info" v-bind:value="info._id">{{info.sname}}</option>
            </select>
          </div>
        </div>-->
        <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label
              for="exampleInputEmail1"
              style="text-align: left !important"
            ></label>
            <select
              class="filter pt-2 pb-2"
              style="width: 100% !important"
              v-model="status"
            >
              <option value selected disabled>Status</option>
              <option v-bind:value="null">All</option>
              <option v-for="st in stat" :key="st">{{ st }}</option>
            </select>
          </div>
        </div>
        <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label for="fromDate" style="font-size: 12px">From Date</label>
            <b-form-input
              id="fromDate"
              v-model="fromDate"
              type="date"
              class="filter"
            ></b-form-input>
          </div>
        </div>
        <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label for="toDate" style="font-size: 12px">To Date</label>
            <b-form-input
              id="toDate"
              v-model="toDate"
              type="date"
              class="filter"
            ></b-form-input>
          </div>
        </div>
      </div>

      <div class="flex md12 sm6 xs12 overflow-auto">
        <div class="overflow-auto" style="overflow: auto">
          <b-table
            hover
            v-if="data.length"
            class="table-sm th table-sm td"
            id="my-table"
            :fields="fields"
            :tbody-tr-class="rowClass"
            :items="data"
            small
            responsive
            borderless
            head-variant="dark"
            table-variant="light"
          >
            <template v-slot:cell(sno)="data">
              <span v-if="currentPage == 1">{{
                totalData - data.item.sno
              }}</span>

              <span v-else>{{
                totalData - ((currentPage - 1) * perPage + data.item.sno)
              }}</span>
              <!-- <span v-if="currentPage > 1">{{
                (currentPage - 1) * perPage + data.item.sno
              }}</span> -->
            </template>
            <template v-slot:cell(CRtype)="data">
              <p v-if="data.item.CRtype == 'groundlevel'">Field Reporting</p>
              <p v-if="data.item.CRtype == 'online'">Online Reporting</p>
            </template>
            <template v-slot:cell(data)="data">
              <p v-if="data.item.uid">{{ data.item.uid.userID }}</p>
              <p v-else>Guest</p>
            </template>
            <template v-slot:cell(create_date)="data">
              <p v-if="data.item.create_date">
                {{ formatDate(data.item.create_date) }}
              </p>
            </template>

            <template v-slot:cell(adminDesc)="data">
              <span v-if="data.item.adminDescription">
               <span data-toggle="tooltip"  class="d-inline-block" tabindex="0"  data-placement="top"  :title="data.item.adminDescription"> {{data.item.adminDescription.slice(0,50)}}</span>
              </span>
              <span v-else>
                -
              </span>
            </template>
               <template v-slot:cell(desc)="data">
              <span v-if="data.item.adminDescription">
               <b-button
                  @click="(descriptionModal = true), (editingItem = data.item), editingItem.descriptionMsg=editingItem.adminDescription"
                  variant="info"
                  >Update
                </b-button>
              </span>
              <span v-else>
                <b-button
                  @click="(descriptionModal = true), (editingItem = data.item)"
                  variant="success"
                  >Add
                </b-button>
              </span>
            </template>
            <template v-slot:cell(_id)="data">
              <span>
                <a :href="'/reportsview/' + data.item._id" target="_self">
                  <b-button  variant="info">View</b-button>
                </a>
              </span>
            </template>

            <template v-slot:cell(userDelete)="data">
              <b-button v-if="appUser.usertype != 2"
                variant="danger"
                @click="deleteReport(data.item._id)"
                >Remove</b-button
              >
            </template>

            <template v-slot:cell(assign)="data">
              <span v-if="appUser.usertype == 0">
                <div v-if="data.item.requestedBy && data.item.requestedBy.length > 0 && !data.item.isAssigned" class="pb-1">
                  <span style="font-size: 11px; color: #dc3545; font-weight: bold;">
                    Requested by: {{ data.item.requestedBy.map(r => r.name || 'Analyst').join(', ') }}
                  </span>
                </div>
                <b-button
                  v-if="data.item.isAssigned"
                  class="text-nowrap"
                  @click="openAssignModal(data.item)"
                  variant="primary"
                  >Re-assign</b-button
                >
                <b-button
                  v-else
                  class="text-nowrap"
                  @click="openAssignModal(data.item)"
                  variant="warning"
                  ><span style="color: #fff">Assign To</span></b-button
                >
              </span>
              <span v-else-if="appUser.usertype == 2 && data.item.status === 'pending' && !data.item.isAssigned">
                <b-button
                  v-if="!hasRequested(data.item)"
                  class="text-nowrap"
                  @click="requestAssignment(data.item._id)"
                  variant="success"
                  >Request Case</b-button
                >
                <b-badge v-else variant="info">Requested</b-badge>
              </span>
            </template>
            <!-- <template v-slot:cell(status)="data">
              <span v-if="data.item.status=='pending'" style="color:#F29339">{{data.item.status }}</span>
              <span v-if="data.item.status=='solved'" style="color:#00A86B">{{data.item.status }}</span>
              <span v-if="data.item.status=='completed'" style="color:#077E8C">{{data.item.status }}</span>
              <span v-if="data.item.status=='disposed'" style="color:#D9512C">{{data.item.status }}</span>
            </template> -->
          </b-table>
          <p v-else>No Data Found</p>
          <br />
          <b-pagination
            align="center"
            v-model="currentPage"
            :total-rows="totalData"
            :per-page="perPage"
            prev-text="Prev"
            next-text="Next"
            @change="nextPage"
            aria-controls="my-table"
          ></b-pagination>
          <br />
        </div>
      </div>
      <b-modal
        size="md"
        v-model="descriptionModal"
        centered
        :hide-backdrop="false"

        hide-footer
        hide-header
      >
        <form @submit="onSubmit">
          <!-- <p class="poppinsbold" style="font-size: 18px">
            NOTIFY THE TEAM MEMBER
          </p> -->
          <div class="pb-3">
            <label style="font-size: 14px" class="poppinsregular">
              Please Enter Description
              <sup>*</sup>
            </label>
            <div class="formgroup">
              <input
                v-model="editingItem.descriptionMsg"
                type="text"
                class="poppinsregular pa-2 form-control"
                placeholder="Description Message"
                style="
                  font-size: 14px;
                  color: black !important;
                  width: 100% !important;
                "
              />
            </div>
          </div>

          <b-row>
            <b-col cols="3">
              <b-button
                variant="danger"
                class="px-2"
                @click="descriptionModal = false"
                >CANCEL</b-button
              >
            </b-col>
            <b-col cols="3">
              <b-button variant="success" class="px-2" type="submit"
                >SUBMIT</b-button
              >
            </b-col>
          </b-row>
        </form>
      </b-modal>
    </va-card>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  components: {
    VueElementLoading,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    showAll: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      id1: '',
      msg: '',
      visible: false,
      assignModal: false,
      selectedCrime: null,
      perPage: 30,
      currentPage: 1,
      dat: [],
      fields: [
        {
          key: 'sno',
          label: 'S.No',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          key: 'crimeReportID',
          label: 'Crime ID',
          tdClass: ' text-capitalize',
          // thClass: " pdngtblcol1",
          // trclass: "pdngtblhead",
        },
        // {
        //   key: "usertype",
        //   label: "User Type",
        //   sortable: false,
        //   tdClass: "pdngtblcol1 text-capitalize",
        //   thClass: " pdngtblcol1",
        //   trclass: "pdngtblhead",
        // },
        {
          key: 'data',
          label: 'User',
          sortable: false,

          // tdClass: "pdngtblcol1 text-capitalize",
          // thClass: " pdngtblcol1",
          // trclass: "pdngtblhead",
        },
        //  {
        //   key: 'uid.fullName',
        //   label: 'Name',
        //   sortable: false,
        //   tdClass: 'pdngtblcol1 text-capitalize',
        //   thClass: ' pdngtblcol1',
        //   trclass: 'pdngtblhead',
        // },
        {
          key: 'crimeType.cname',
          label: 'Crime',
          sortable: false,
          tdClass: 'text-capitalize ',
          //  thClass:"pdngtblhead"
        },
        {
          key: 'CRtype',
          label: 'Level of Reporting',
          sortable: false,
          //  thClass:"pdngtblhead"
          // tdClass: "w-20",
        },
        {
          key: 'status',
          sortable: false,
          tdClass: ' text-capitalize',
          // thClass:"pdngtblhead"
        },
        {
          key: 'create_date',
          label: 'Reported Date',
          sortable: false,
          tdClass: 'text-center ',
          thClass: 'text-center',
        },
        {
          key: 'adminDesc',
          label: ' Admin Description',
          sortable: false,
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          key: 'desc',
          label: 'Add Admin Description',
          sortable: false,
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          label: 'Case Details',
          key: '_id',
          sortable: false,
          //  thClass:"pdngtblhead",
          // tdClass: "tblbutton",
        },
        {
          label: 'Remove Case',
          key: 'userDelete',
          sortable: false,
          thClass: 'cnt',
          tdClass: 'cnt',
        },
        {
          label: 'Assign Case',
          key: 'assign',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center text-nowrap',
        },
      ],
      data: [],
      data1: [],
      usertype: '',
      CRtype: '',
      crimeType: '',
      source: '',
      status: '',
      stat: '',
      ctype: [],
      Sour: '',
      totalData: '',
      analysts: [],
      analystId: null,
      crimeId: null,
      keyword: null,
      editingItem: {
        descriptionMsg: null,
      },
      descriptionModal: false,
      descriptionMsg: null,
      fromDate: null,
      toDate: null,
    }
  },

  mounted: function () {
    if (this.type != 'noData') this.status = this.type
    else this.status = ''
    this.getList()
    this.analystList()
    this.statview()
    this.crimeview()
    this.infoview()
  },
  computed: {
    rows () {
      return this.data.length
    },
    appUser () {
      if (this.$store.state.userData) return this.$store.state.userData
      else return {}
    },
  },
  watch: {
    crimeType: function () {
      this.getList()
    },
    status: function () {
      this.getList()
    },
    source: function () {
      this.getList()
    },
    usertype: function () {
      this.getList()
    },
    CRtype: function () {
      this.getList()
    },
    keyword: function () {
      this.getList()
    },
    fromDate: function () {
      this.getList()
    },
    toDate: function () {
      this.getList()
    },
    showAll: function () {
      this.getList()
    },
    type: function (newVal) {
      if (newVal != 'noData') this.status = newVal
      else this.status = ''
      this.getList()
    },
  },

  methods: {
    formatDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    rowClass (item, type) {
      if (!item || type !== 'row') return
      if (item.status === 'pending') return 'table-warning'
      if (item.status === 'stored') return 'table-danger'
      if (item.status === 'completed') return 'table-info'

      if (item.status === 'solved') return 'table-success'
    },
    nextPage (ev) {
      this.currentPage = ev
      this.getList()
    },
    deleteReport (val) {
      if (confirm('Are you sure?')) {
        this.visible = true
        axios({
          method: 'POST',

          headers: {
            token: localStorage.getItem('token'),
          },
          url: '/admin/crimereport/delete/' + val,
        })
          .then((response) => {
            this.visible = false
            if (response.data.status) {
              this.msg = response.data.msg
              this.$dlg.alert(this.msg, () => {}, { messageType: 'success' })
              this.getList()
            } else {
              this.msg = response.data.msg
              this.$dlg.alert(this.msg, () => {}, { messageType: 'error' })
            }
          })
          .catch((err) => {
            this.visible = false
            this.errors.push(err)
            this.$dlg.alert(
              this.msg,
              () => {
                // this.$router.push("/Dashboard");
              },
              { messageType: 'error' }
            )
          })
      } else {
        this.getList()
      }
    },
    analystList () {
      axios({
        method: 'POST',
        url: '/admin/list',
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          this.analysts = response.data.data
          this.analystId = this.analysts[0]._id
        })

        .catch((err) => {
          console.log(err)
        })
    },
    crimeview () {
      // this.visible = true;
      axios({
        method: 'GET',
        url: '/crimetype/list',
      })
        .then((response) => {
          this.ctype = response.data.data
          // this.visible = false;
        })

        .catch((err) => {
          // this.visible = false;
          console.log(err)
        })
    },
    statview () {
      // this.visible = true;
      axios({
        method: 'GET',
        url: '/status/list',
      })
        .then((response) => {
          this.stat = response.data.data
          // this.visible = false;
        })
        .catch((err) => {
          // this.visible = false;
          console.log(err)
        })
    },
    infoview () {
      // this.visible = true;
      axios({
        method: 'POST',
        url: '/source/list',
      })
        .then((response) => {
          this.Sour = response.data.data

          // this.visible = false;
        })
        .catch((err) => {
          // this.visible = false;
          console.log(err)
        })
    },

    getList () {
      this.visible = true
      var data1 = {}
      if (this.usertype !== '') {
        data1['usertype'] = this.usertype
      }
      if (this.keyword) {
        data1['keyword'] = this.keyword
      }
      if (this.CRtype !== '') {
        data1['CRtype'] = this.CRtype
      }
      if (this.crimeType !== '') {
        data1['crimeType'] = this.crimeType
      }
      if (this.source !== '') {
        data1['source'] = this.source
      }
      if (this.status !== '') {
        data1['status'] = this.status
      }
      if (this.fromDate) {
        data1['fromDate'] = this.fromDate
      }
      if (this.toDate) {
        data1['toDate'] = this.toDate
      }
      data1['page'] = this.currentPage
      data1['limit'] = this.perPage
      if (this.showAll) {
        data1['allReports'] = true
      }

      axios({
        method: 'POST',
        url: '/crimereports/all/list',
        data: data1,
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          // console.log(response.data.data)
          //  this.posts = response.data.data;

          // this.data = response.data.data
          // this.crimeType = response.data.data.crimeType.
          for (var i = 0; i < response.data.data.length; i++) {
            response.data.data[i].sno = i
          }
          if (response.data.status === true) {
            this.data = response.data.data
            this.totalData = response.data.totalLength

            this.visible = false
          } else if (response.data.status === false) {
            this.visible = false

            //  var tempData=[]
            // if (response.data.status === true) {
            //    this.data = response.data.data;
            //    var j= 0
            //    for (var i = this.totalData;i > this.perPage;i--) {

            //    this.data[j].sno = i;
            //    j=j+1
            //   console.log("data",this.totalData[j].sno,i,j)
            // }
            //   // this.data=tempData

            //   this.visible = false;
          } else if (response.data.status === false) {
            this.visible = false

            // var temp = []

            // for (var j = 0; j < this.data.length; j++) {
            //   var ty = this.data[j].crimeType.cname

            //   temp.push(ty)
            // }
            // this.ctype = temp
          }
        })
        .catch((e) => {
          console.log(e)
          this.visible = false
          // this.errors.push(e)
          this.msg = 'failed'
        })
    },
    onSubmit (evt) {
      this.visible = true
      evt.preventDefault()
      var data1 = {}
      data1['id'] = this.editingItem._id
      data1['adminDescription'] = this.editingItem.descriptionMsg
      axios({
        method: 'POST',
        url: '/crimereports/add/update/adminDescription',
        data: data1,
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.visible = false
            this.getList()

            this.descriptionModal = false
          } else {
            this.visible = false
          }
        })
        .catch((err) => {
          console.log(err)
          // if (err.response.data.status === false) {
          //   this.msg = "Please Try Again";
          // }
        })
    },
    hasRequested (item) {
      if (!item.requestedBy) return false
      return item.requestedBy.some(req => {
        if (typeof req === 'object' && req !== null) {
          return req._id === this.appUser._id
        }
        return req === this.appUser._id
      })
    },
    getAnalystName (req) {
      if (typeof req === 'object' && req !== null) {
        return req.name || 'Analyst'
      }
      const analyst = this.analysts.find(a => a._id === req)
      return analyst ? analyst.name : 'Analyst'
    },
    openAssignModal (item) {
      this.selectedCrime = item
      this.crimeId = item._id
      this.assignModal = true
      if (item.requestedBy && item.requestedBy.length > 0) {
        const firstReq = item.requestedBy[0]
        this.analystId = typeof firstReq === 'object' ? firstReq._id : firstReq
      } else if (this.analysts && this.analysts.length > 0) {
        this.analystId = this.analysts[0]._id
      } else {
        this.analystId = null
      }
    },
    requestAssignment (id) {
      this.visible = true
      axios({
        method: 'POST',
        headers: {
          token: localStorage.getItem('token'),
        },
        url: '/crimereport/request-assignment',
        data: { id: id },
      })
        .then((response) => {
          this.visible = false
          if (response.data.status) {
            this.getList()
            this.$dlg.alert(response.data.msg, () => {}, {
              messageType: 'success',
              title: 'Request Successful',
            })
          } else {
            this.$dlg.alert(response.data.msg, () => {}, {
              messageType: 'error',
              title: 'Request Failed',
            })
          }
        })
        .catch((e) => {
          console.log(e)
          this.visible = false
        })
    },
    assign (id) {
      this.visible = true
      var data = {}
      data['id'] = this.crimeId
      data['analystId'] = this.analystId
      axios({
        method: 'POST',
        headers: {
          token: localStorage.getItem('token'),
        },
        url: '/crimereport/assign/analyst',
        data: data,
      })
        .then((response) => {
          if (response.data.status) {
            this.visible = false
            this.getList()

            this.assignModal = false
            this.$dlg.alert((this.msg = response.data.msg), () => {}, {
              messageType: 'success',
              title: 'Assignment Successful',
            })
          } else {
            this.assignModal = false
            this.visible = false

            this.$dlg.alert((this.msg = response.data.msg), () => {}, {
              messageType: 'error',
              title: 'Assignment Failed',
            })
          }
        })
        .catch((e) => {
          console.log(e)
          this.visible = false
        })
    },
    exportCrimeReports () {
      this.visible = true
      var data = {}
      if (this.fromDate) data.fromDate = this.fromDate
      if (this.toDate) data.toDate = this.toDate
      if (this.usertype !== '') data.usertype = this.usertype
      if (this.crimeType !== '') data.crimeType = this.crimeType
      if (this.CRtype !== '') data.CRtype = this.CRtype
      if (this.status !== '') data.status = this.status
      if (this.keyword) data.keyword = this.keyword
      if (this.showAll) {
        data.allReports = true
      }

      axios({
        method: 'POST',
        url: '/export/crimereports/excel',
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data,
        responseType: 'blob',
      })
        .then((response) => {
          this.visible = false
          var fileURL = window.URL.createObjectURL(new Blob([response.data]))
          var link = document.createElement('a')
          link.href = fileURL
          link.download = 'Crime_Reports.xlsx'
          link.click()
        })
        .catch((err) => {
          this.visible = false
          console.log(err)
        })
    },
    exportOffenders () {
      this.visible = true
      axios({
        method: 'POST',
        url: '/export/offenders/excel',
        headers: {
          token: localStorage.getItem('token'),
        },
        responseType: 'blob',
      })
        .then((response) => {
          this.visible = false
          var fileURL = window.URL.createObjectURL(new Blob([response.data]))
          var link = document.createElement('a')
          link.href = fileURL
          link.download = 'Accused_Database.xlsx'
          link.click()
        })
        .catch((err) => {
          this.visible = false
          console.log(err)
        })
    },
  },
}
</script>
<style>
.pdngtblcol {
  padding-right: 50px !important;
}
.pdngtblcol1 {
  padding-left: 30px !important;
}

.pdngtblhead {
  padding-top: 30px !important;
  margin-top: 30px !important;
  padding-bottom: 30px !important;
}
.thead-dark {
  padding-top: 80px !important;
}
.table-sm th,
.table-sm td {
  padding: 12px !important;
}
.filter {
  width: 100% !important;
}
.tblbutton {
  text-align: right !important;
  /* width: 0% !important; */
}

</style>
